import { AnyAction } from '@reduxjs/toolkit'
import { get, has, sortBy } from 'lodash'

import * as actionTypes from './actionTypes'

type SpaceChatbotCorporateDictionaryPageState = {
  definition: {
    title: string
    synonyms: unknown[]
    url: string
  }
  definitions: any[]
  pendingDefinitions: unknown[]
  previousPath: string
  definitionsToPublish?: unknown
  createdDefinition?: unknown
  selectedDefinition?: { title: string; synonyms: unknown[]; description: string; contact: string; url: string }
  updatedDefinition?: unknown
}

const initialState: SpaceChatbotCorporateDictionaryPageState = {
  definition: {
    title: '',
    synonyms: [],
    url: ''
  },
  definitions: [],
  pendingDefinitions: [],
  previousPath: 'summary'
}

export default function dictionaryReducer(
  state = initialState,
  action: AnyAction
): SpaceChatbotCorporateDictionaryPageState {
  let definitions = []
  switch (action.type) {
    case actionTypes.FETCH_DEFINITIONS_SUCCESS: {
      definitions = get(action.response, 'items')
      return {
        ...state,
        definitions: definitions.map((definition: any, index: number) => {
          const status = definition.status || 'published'
          return { ...definition, index: index, status: status }
        }),
        pendingDefinitions: getPendingDefinitions(definitions)
      }
    }
    case actionTypes.UPDATE_DEFINITIONS_TO_PUBLISH: {
      return {
        ...state,
        definitionsToPublish: action.definitionsToPublish,
        previousPath: action.previousPath
      }
    }
    case actionTypes.CREATE_DEFINITION_SUCCESS: {
      definitions = get(state, 'definitions')
      if (has(action, 'response')) definitions.push(action.response)
      return {
        ...state,
        definitions: definitions.map((definition, index) => {
          const status = definition.status || 'published'
          return { ...definition, index: index, status: status }
        }),
        pendingDefinitions: getPendingDefinitions(definitions),
        createdDefinition: action.response,
        selectedDefinition: { title: '', synonyms: [], description: '', contact: '', url: '' }
      }
    }
    case actionTypes.UPDATE_DEFINITION_SUCCESS: {
      definitions = get(state, 'definitions')
      return {
        ...state,
        definitions: definitions.map((definition, index) => {
          if (has(action, 'response') && definition.title === get(action, 'response.title')) {
            definition = action.response
          }
          const status = definition.status || 'published'
          return { ...definition, index: index, status: status }
        }),
        pendingDefinitions: getPendingDefinitions(definitions),
        updatedDefinition: action.response
      }
    }
    case actionTypes.REMOVE_DEFINITION_SUCCESS: {
      definitions = get(state, 'definitions')

      const updatedDefinitions =
        has(action, 'response') && has(action, 'response.title')
          ? definitions.filter(definition => {
              return definition.title !== get(action, 'response.title')
            })
          : definitions
      return {
        ...state,
        definitions: updatedDefinitions,
        pendingDefinitions: getPendingDefinitions(updatedDefinitions),
        selectedDefinition: { title: '', synonyms: [], description: '', contact: '', url: '' }
      }
    }
    default: {
      return state
    }
  }
}

const getPendingDefinitions = (definitions: any[]) => {
  return sortBy(
    definitions.filter(definition => {
      return definition.status && definition.status.toLowerCase().includes('pending')
    }),
    o => o.lastUpdatedDate
  ).reverse()
}
